module.exports = __webpack_public_path__ + "static/media/calendar-check.c7ea3aea.svg";